export const endingPageFallback = {
	disclaimer: {
		title: "Disclaimer",
		description: `The contents of this document are communicated by, and the property of, MDOTM LTD. MDOTM LTD is an appointed
	representative of Thornbridge Investment Management LLP which is authorised and regulated by the Financial
	Conduct Authority (“FCA”). The information and opinions contained in this document are subject to updating
	and verification and may be subject to amendment. No representation, warranty, or undertaking, express or
	limited, is given as to the accuracy or completeness of the information or opinions contained in this
	document by MDOTM LTD or its directors. No liability is accepted by such persons for the accuracy or
	completeness of any information or opinions. As such, no reliance may be placed for any purpose on the
	information and opinions contained in this document. This document is directed at persons who fall within
	the definition of ‘professional clients’ or ‘eligible counterparties’ as defined in the rules of the
	Financial Conduct Authority (“FCA”) of the United Kingdom. The information contained in this document is
	strictly confidential. The value of investments and any income generated may go down as well as up and is
	not guaranteed. Past performance is not necessarily a guide to future performance.`,
	},
	address:
		"MDOTM Ltd | MDOTM Srl\nLondon\n13 Austin Friars\nEC2N 2HE, London\nUnited Kingdom\nMilan\nVia Passione, 8\n20122 Milan\nItaly",
	mail: "info@mdotm.eu",
	website: "www.mdotm.eu",
} as const;
